module.exports = __webpack_public_path__ + "img/video604.ca53a32e.jpg";